import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { NewAccountStepsComponent } from '../../components/new-account-steps/new-account-steps.component';
import { LayoutBaseComponent } from '../../../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../../../shared-module/components/top-bar/top-bar.component';
import { NewAccountStoreSelectors } from '../../../root-store/new-account-store';
import { ActiveRouteService } from '../../../shared-module/services';

@Component({
	selector: 'new-account-layout',
	templateUrl: './new-account-layout.component.html',
	imports: [LayoutBaseComponent, NewAccountStepsComponent, TopBarComponent, RouterOutlet, AsyncPipe]
})
export class NewAccountLayoutComponent extends LayoutBaseComponent {
	private activeRouteService = inject(ActiveRouteService);
	protected store = inject(Store);

	currentStep$ = this.store.select(NewAccountStoreSelectors.selectCurrentStep);
	selectedSubsidiary$ = this.store.select(NewAccountStoreSelectors.selectSelectedSubsidiarySlice);

	tenantTitle$ = this.activeRouteService.tenantTitle$;
}
